import { Icon } from "../../../../Components/Icon";
import { EmployeeRole } from "../../../../Utilities";

export type EmployeeRoleIconProps = {
	role: EmployeeRole;
} & Icon.IconProps;

export function EmployeeRoleIcon({ role, ...props }: EmployeeRoleIconProps) {
	// TODO swap icon libraries
	switch (role) {
		case EmployeeRole.Teacher:
			return <Icon.GraduationCap {...props} />;
		case EmployeeRole.AcademicAdmin:
		case EmployeeRole.GeneralAdmin:
		case EmployeeRole.GeneralStaff:
		case EmployeeRole.PrincipalAdmin:
			return <Icon.IdentificationCard {...props} />;
		case EmployeeRole.FinancialAdmin:
			return <Icon.Bank {...props} />;
	}
	return null;
}
